import { useRecordContext } from "react-admin";
import ReturnCorrectionModal from "components/CareerCenter/Partials/ReturnCorrectionModal";
import { careerCenterRequests } from "api/careerCenterApi";
import { JOBS } from "utils/constants";

const ReturnJobForCorrection = () => {
  const record = useRecordContext();

  return (
    <ReturnCorrectionModal
      correctionsUrl={careerCenterRequests.returnForCorrectionJobOffer(record?.id)}
      type={JOBS}
    />
  );
};

export default ReturnJobForCorrection;
